module.exports = __webpack_public_path__ + "static/media/apartment3a.198ab594.jpg";